<template>
    <hts-form-select
        v-model="cValue"
        v-model:text="cText"
        :query="query"
        :filterable="filterable"
        :clearable="clearable"
        :label="label"
        :required="required"
        :selected-multiple="selectedMultiple"
        :multiple="multiple"
        :prop="prop"
        :name="name || prop"
        :disabled="disabled"
        key-id="_id"
        key-label="name"
        @change="handleChange">
        <template
            v-if="showBusiness"
            #default="{ item }">
            <span>
                {{ item.name }}
            </span>
            <div class="block w-full">
                <template v-if="item.businesses && Array.isArray(item.businesses) && item.businesses.length">
                    <span
                        v-for="(business, index) in filteredBusinesses(item.businesses)"
                        :key="index"
                        class="inline-block whitespace-nowrap overflow-hidden text-ellipsis max-w-xs text-sm p-1 m-1 border rounded text-gray-500">
                        {{ getBusinessName(business) }}
                    </span>
                </template>
            </div>
        </template>
    </hts-form-select>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: [Array, String],
    default: () => ''
  },
  multiple: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: ''
  },
  selectedMultiple: {
    type: [Array, Object],
    default: () => []
  },
  required: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    default: 'task'
  },
  prop: {
    type: String,
    default: 'task'
  },
  label: {
    type: String,
    default: () => $t('labels.task')
  },
  filterable: {
    type: Boolean,
    default: true
  },
  clearable: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  taskType: {
    type: String,
    default: 'AFFECT_SHIPPING_TIME'
  },
  showBusiness: {
    type: Boolean,
    default: true
  }
})

const emits = defineEmits(['update:modelValue', 'update:text', 'click'])
const store = $store()
const businesses = computed(() => store.data.businesses)

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const { modelValue, name, required, multiple, text, taskType } = toRefs(props)

const query = async (s: string) => {
  const api: any = $urlSystem.business.task.select

  const res = await $api(api, {
    uriParams: {
      KEY: s,
      TASKTYPE: taskType.value
    }
  })
  const resData: any = res?.data?.value
  if (resData?.success) {
    return resData.data
  }
  return []
}
const cText = computed({
  get () {
    return text.value || ''
  },
  set (val: any) {
    emits('update:text', val)
  }
})
const information = ref([])

const handleChange = (val: any) => {
  information.value = val
}

const filteredBusinesses = (ids: string[]) => {
  if (!ids || !businesses) {
    return []
  }

  return ids.filter((id: string) => {
    const exist: any = businesses.value.find((b: any) => b._id === id)
    if (exist && !exist?.deleted) {
      return true
    }
    return false
  })
}

const getBusinessName = (id: string) => {
  const exists: any = businesses.value.find((b: any) => b._id === id)
  if (exists) {
    return exists.name || ''
  }
  return ''
}
</script>
